// Widget CSS
import '@/css/_elementor/widgets/product_card_slider.css';

// ..........................................................................................

function initProductCardSlider(scopeEl) {
	const slider = scopeEl.querySelector('.slider-product_card_slider');

	if (!slider) return;

	const wrapper = slider.querySelector('.swiper-wrapper');

	if (!wrapper) return;

	const slidesCount = wrapper.children.length || 1;

	const loop = slider.dataset.loop || false;
	const speed = Number(slider.dataset.speed) || 750;
	const spaceBetween = Number(slider.dataset.spaceBetween) || 14;

	const pagination = slider.querySelector('.swiper-pagination');

	const productSlider = new Swiper(slider, {
		speed: speed,
		loop: loop,
		loopPreventsSliding: false,
		loopAdditionalSlides: Math.max(3, slidesCount),
		threshold: 0,
		grabCursor: true,
		watchSlidesProgress: true,
		watchSlidesVisibility: false,
		freeMode: {
			enabled: true,
			momentumBounce: false,
		},
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},

		spaceBetween: spaceBetween,
		slidesPerView: 1,
		slidesOffsetAfter: 20,

		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: Math.max(spaceBetween, 16),
			},
			1280: {
				slidesPerView: Math.min(2, slidesCount),
				spaceBetween: Math.max(spaceBetween, 24),
			},
			1440: {
				slidesPerView: Math.min(3, slidesCount),
				spaceBetween: Math.max(spaceBetween, 24),
			},
		},

		...(pagination
			? {
					pagination: {
						el: pagination,
						clickable: true,
					},
				}
			: {}),
	});

	slider._productCardSwiper = productSlider;
}

// ..........................................................................................

window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/product_card_slider.default', (scope) => {
		const scopeEl = scope[0];

		if (!scopeEl) return;

		const slider = scopeEl.querySelector('.slider-product_card_slider');

		if (!slider) return;

		if (slider._productCardSwiper) {
			slider._productCardSwiper.destroy(true, true);

			slider._productCardSwiper = null;
		}

		initProductCardSlider(scopeEl);
	});
});
